import styled from 'styled-components';

import { Banner, Flex, spaceMixin, token } from '@zillow/constellation';

export const StyledContainer = styled.div`
  margin: 0 -${spaceMixin('sm')};
`;

export const StyledBanner = styled(Banner)`
  position: absolute;
  z-index: ${token('zIndices.toast')};
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
`;

export const StyledIFrameContainer = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.5);
`;
